export default {"src":"/_next/static/media/pricing-comment.b1931d70.svg","height":24,"width":24};